import ko from "knockout";
import viewHtml from "./ko-sortable-list.html";

export interface ISortableItem {
    id: string;
    name: string;
    order: KnockoutObservable<number>;
    isVisible: KnockoutObservable<boolean>;
}

export interface ISortableListParams {
    items: KnockoutObservableArray<ISortableItem>;
}

class SortableList {
    items: KnockoutObservableArray<ISortableItem>;
    sortedItems: KnockoutObservable<ISortableItem[]>;
    activeItemId = ko.observable<string>();
    currentItem: ISortableItem = undefined;

    constructor(params: ISortableListParams) {
        this.items = params.items;
        this.sortedItems = ko.computed(() =>
            this.items()
                ?.slice()
                .sort((a, b) => a.order() - b.order())
        );
    }

    dragStart(item: ISortableItem, event: JQuery.DragEvent) {
        this.currentItem = item;
        this.activeItemId(item.id);
        const target = event.target as HTMLElement;
        target.classList.add("active");

        event.originalEvent.dataTransfer.setData("id", item.id);
        event.originalEvent.dataTransfer.dropEffect = "move";
        event.originalEvent.dataTransfer.effectAllowed = "move";

        return true;
    }

    dragOver(item: ISortableItem, event: DragEvent) {
        event.preventDefault();

        if (!this.currentItem || item === this.currentItem) {
            return;
        }

        const target = event.target as HTMLElement;
        const height = target.clientHeight;
        if (event.offsetY > height / 2) {
            this.moveItem(this.currentItem, item.order() + 1);
        } else {
            this.moveItem(this.currentItem, item.order());
        }
    }

    dragEnd(_item: ISortableItem, event: DragEvent) {
        const target = event.target as HTMLElement;
        target.classList.remove("active");
        this.currentItem = undefined;
    }

    moveItem(draggedItem: ISortableItem, newOrder: number) {
        if (draggedItem.order() == newOrder) return;

        // Shift items after
        this.items()?.forEach(item => {
            if (item === draggedItem) {
                item.order(newOrder);
            } else if (item.order() >= newOrder) {
                item.order(item.order() + 1);
            }
        });

        // Defrag
        this.sortedItems().forEach((item, index) => {
            item.order(index + 1);
        });
    }
}

ko.components.register("ko-sortable-list", {
    viewModel: SortableList,
    template: viewHtml,
    synchronous: true
});
